import { BadgeCheck, BookOpen, LayoutGrid, Search } from "lucide-react";
import { Link } from "react-router-dom";

const CARDS = [
  {
    icon: BadgeCheck,
    color: "#0E8A78",
    bg: "rgba(14,138,120,0.08)",
    title: "Verified Teachers",
    desc: "Every teacher profile is reviewed by our team before going live. You only see teachers who have passed our checks.",
    to: "/search/one-to-one",
  },
  {
    icon: BookOpen,
    color: "#2F6BD8",
    bg: "rgba(47,107,216,0.08)",
    title: "India-Focused Subjects",
    desc: "CBSE, IGCSE, IIT-JEE, NEET and 50+ more subjects — taught by teachers who know the syllabus.",
    to: "/subjects",
  },
  {
    icon: LayoutGrid,
    color: "#D9472B",
    bg: "rgba(217,71,43,0.08)",
    title: "Three Ways to Learn",
    desc: "Choose 1-on-1 private sessions, group classes, or time-bound crash courses — whatever suits you best.",
    to: "/how-it-works",
  },
  {
    icon: Search,
    color: "#262A7A",
    bg: "rgba(38,42,122,0.08)",
    title: "Free to Browse",
    desc: "No signup needed to explore teachers and offerings. Search, compare, and decide at your own pace.",
    to: "/search",
  },
];

export function WhyBMCSection() {
  return (
    <section className="py-14 sm:py-20 bg-[#EEEFF9]">
      <div className="container mx-auto px-4 lg:px-8">

        <div className="mb-10 text-center">
          <span className="inline-block text-xs font-semibold uppercase tracking-widest text-[#262A7A] mb-3 px-3 py-1 rounded-full bg-[#EEEFF9]">
            The BMC Difference
          </span>
          <h2 className="font-sans text-2xl sm:text-3xl font-semibold text-[#262A7A]">
            Why choose BookMyCoaching?
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {CARDS.map(({ icon: Icon, color, bg, title, desc, to }) => (
            <Link
              key={title}
              to={to}
              className="rounded-2xl border border-[#DCDDEE] bg-white p-6 flex flex-col gap-4 hover:shadow-md hover:-translate-y-0.5 transition-all duration-200 group"
            >
              <div
                className="w-11 h-11 rounded-xl flex items-center justify-center flex-shrink-0"
                style={{ background: bg }}
              >
                <Icon className="w-5 h-5" style={{ color }} />
              </div>
              <div>
                <p className="font-semibold text-[#262A7A] text-base mb-1 group-hover:text-[#363A96] transition-colors">{title}</p>
                <p className="text-sm text-[#5A5E80] leading-relaxed">{desc}</p>
              </div>
            </Link>
          ))}
        </div>

      </div>
    </section>
  );
}
